export function ModalIconHelpPlaySVG({ width, height, viewBox }) {
	return (
		<svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect y="0.884277" width="18" height="3" rx="1.5" fill="#D9D9D9" />
		</svg>
	)
}
